export class TonerJsEnv {
  printerMakers: string[];
  printerTypes: number[];
  printerModels: string[];
  selectedPrinterMaker: string;
  selectedPrinterType: number | null;
  selectedPrinterModel: string;

  constructor(
    printerMakers: string[],
    printerTypes: number[],
    printerModels: string[],
    selectedPrinterMaker: string,
    selectedPrinterType: number | null,
    selectedPrinterModel: string,
    ) {
    this.printerMakers = printerMakers;
    this.printerTypes = printerTypes;
    this.printerModels = printerModels;
    this.selectedPrinterMaker = selectedPrinterMaker;
    this.selectedPrinterType = selectedPrinterType
    this.selectedPrinterModel = selectedPrinterModel;
  }
}
